import { useFormAutosave } from '../../form'
import { OnFormSubmit } from '../../form/types'
import OrderAcceptedToggleItem from './OrderAcceptedToggleItem'
import OrderAwaitingAcceptanceToggleItem from './OrderAwaitingAcceptanceToggleItem'
import React, { FC } from 'react'
import { StyleSheet, View } from 'react-native'

interface ContentProps {
    onFormSubmit: OnFormSubmit
}

const Content: FC<ContentProps> = ({ onFormSubmit }) => {
    const { isSubmitting } = useFormAutosave(onFormSubmit)

    return (
        <View style={styles.content}>
            <OrderAwaitingAcceptanceToggleItem disabled={isSubmitting} />
            <OrderAcceptedToggleItem disabled={isSubmitting} />
        </View>
    )
}

const styles = StyleSheet.create({
    content: {
        paddingHorizontal: 24,
    },
})

export default Content
